import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthContext from '../../../store/auth-context';
import ODropDownMenu from '../../components/UI/DropDownMenu/ODropDownMenu';
import { useTranslation } from 'react-i18next';

function UserOptions({ children }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const authContext = useContext(AuthContext);

  // const onProfile = () => {
  //   navigate(`${location.pathname}${'profil'}`);
  // };
  const onPassword = () => {
    navigate(`${location.pathname}${'promena-podataka'}`);
  };
  const onLogout = () => {
    authContext.logout();
  };

  const userOptions = [
    // {
    //   title: 'Profil',
    //   subtitle: 'Izmena korisničkih informacija',
    //   path: 'profil',
    //   id: 1,
    //   icon: 'fas fa-user',
    //   color: '#2f3a3f',
    //   onClick: onProfile,
    // },
    {
      title: t('buttons.changePassword'),
      subtitle: t('buttons.changePasswordForLogin'),
      path: 'promena-podataka',
      id: 2,
      icon: 'fas fa-unlock-alt',
      color: '#2f3a3f',
      onClick: onPassword,
    },
    {
      title: t('buttons.logOut'),
      // subtitle: 'Odjavite se iz programa',
      path: 'login',
      id: 3,
      icon: 'fas fa-sign-out-alt',
      color: '#ff5552',
      onClick: onLogout,
    },
  ];

  return (
    <ODropDownMenu align="end" options={userOptions}>
      {children}
    </ODropDownMenu>
  );
}

export default UserOptions;
